import { AppSettings } from '../constants';
import Jwt from '../helper/interceptors';
import { ObjToParam, MapResponse } from '../helper/helper-api';

export const getByEmailOfSub = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .get(`/api/clients/get-user-sub-by-email/${params}`)
    .then(response => {
      if (response.status === 204) {
        return {
          statusCode: 200,
          data: null
        };
      }
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSubByname = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .post('/apiv1/subcontractors/check-subcontractor-name', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const addSubcontractor = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post('/api/clients/add-subcontractor', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const editSubcontractor = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .put(`/apiv1/subcontractors/${params.subcontractorId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchSubcontractor = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`/apiv1/subcontractors/search?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const cloneSubcontractor = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .post(`/apiv1/subcontractors/${params.subId}/clone`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const inviteSubAdmin = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(`/api/clients/invite-sub-admin/${params.subId}`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const assign = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post('/api/sub-of-projects/assign', params)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const search = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(
      `/api/sub-of-projects/search-subcontractor-assignments?${ObjToParam(
        params
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchSubcontractorAssignments = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .get(
      `/api/sub-of-projects/search-subcontractor-assignments?${ObjToParam(
        params
      )}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const selectListSubcontractor = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(
      `/api/sub-of-projects/${params.projectId}/${params.lotId}/${
        params.tradeId
      }/subcontractors-select-list?${ObjToParam(params.param)}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const searchAllSubcontractorSelectList = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI, false)
    .get(
      // `/api/sub-of-projects/subcontractors-select-list?${ObjToParam(params)}`
      `/api/reports/subcontractor-select-list?${ObjToParam(params)}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSubById = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(`/apiv1/subcontractors/${params.subId}`, {})
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const resendInvite = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .post(
      `/api/subcontractor/accounts/${params.subId}/resend-invite`,
      params.data
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const assignTradeToSubcontractor = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .post(`/apiv1/subcontractors/${params.subId}/trades`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const deleteInactiveSuperAdmin = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .delete(`/apiv1/subcontractors/${params.subId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const getSubcontractorSuggestion = params => {
  return Jwt(AppSettings.GLOBAL_API_URL)
    .get(
      `/apiv1/subcontractors/select-list-subcontractors?${ObjToParam(params)}`
    )
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

export const removeSuperAdminFromSubcontractor = params => {
  return Jwt(AppSettings.SITE_ONE_SERVICE_URI)
    .delete(`/api/clients/remove-sub-admin/${params.subId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      var response = error.response;
      return MapResponse(response);
    });
};

//api for subcontractor assignment to set active
export const removeSubcontractorAssignment = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .delete(`/api/sub-of-projects/subcontractor-assignments?${ObjToParam(params)}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//api for add contactpoint in subcontractor information
export const addContactPointSubcontractor = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .post(`/api/subcontractors/${params.subcontractorId}/contact-points`, params.data)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};

//apio for delete contactpoint in subcontractor information
export const removeContactPointSubcontractor = params => {
  return Jwt(AppSettings.CURRENT_SITE_URI)
    .delete(`/api/subcontractors/${params.contactPointId}`)
    .then(response => {
      return MapResponse(response);
    })
    .catch(error => {
      const response = error.response;
      return MapResponse(response);
    });
};



// WEBPACK FOOTER //
// ./src/Subcontractors/api.js